import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export type DialogSegment = { text: string; bold?: boolean };

@Component({
  standalone: false,
  selector: 'digicem-option-dialog',
  templateUrl: './option-dialog.component.html',
})
export class OptionDialogComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  protected detail?: string;
  protected detail2?: string;
  protected detailSegments: DialogSegment[][] | null;
  protected title: string;
  protected acceptLabel: string;
  protected onAccept: (id: string) => void;
  protected isLoading = false;
  private objectId: string;
  private action: Observable<unknown>;
  private errorMessage: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: {
      detail?: string;
      detail2?: string;
      detailSegments?: DialogSegment[][];
      title: string;
      objectId: string;
      acceptLabel?: string;
      onAccept: (id: string) => void;
      action: Observable<unknown>;
      errorMessage?: string;
    },
    private dialog: MatDialogRef<OptionDialogComponent>,
    private snackBar: MatSnackBar,
  ) {
    this.detail = data.detail;
    this.detail2 = data.detail2;
    this.detailSegments = data.detailSegments ?? null;
    this.title = data.title;
    this.acceptLabel = data.acceptLabel ?? 'Si, estoy seguro';
    this.onAccept = data.onAccept;
    this.objectId = data.objectId;
    this.action = data.action;
    this.errorMessage = data.errorMessage ?? 'No se pudo pagar el pedido.';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected onAcceptClick(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.action.pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.onAccept(this.objectId);
        this.dialog.close();
      },
      error: () => {
        this.snackBar.open(this.errorMessage, 'Cerrar', { duration: 5000 });
        this.dialog.close();
      },
    });
  }

  protected onCancel(): void {
    this.dialog.close();
  }
}
